/* eslint-disable jsx-a11y/anchor-is-valid */
import { useTranslation } from "react-i18next";
import { DialogWrapper } from "../common/dialogWrapper";
import { Box } from "@mui/material";
import { TextWrapper } from "../formUtilities/useTextWrapper";
import { ButtonWrapper } from "../formUtilities/useButton";
import Coin from '../../../assets/images/coin-up-arrow.png';

export const AutoInvestDialog = ({ state = false, onClose = () => { } }) => {
  const { t } = useTranslation();
  return <DialogWrapper
    preventOutsideClick
    dialogBodyClass="!p-0"
    titleClass="!w-full !items-center"
    width={'380px'}
    state={state}
    hideCloseBtn
    onClose={() => {
      onClose(false);
    }}
    // title={t('autoInvesting')}
    content={
      <Box className="!text-sm flex flex-col items-center space-y-4 text-center">
        <Box className='h-[70px] !bg-[#33CD87] !text-white w-full relative'>
          <Box className='absolute left-1/2 transform -translate-x-1/2 top-[30px] shadow-sm bg-white p-5 rounded-full'>
            <img src={Coin} alt="Coin" className="h-10 w-10" />
          </Box>
        </Box>
        <Box className='!mt-[34px] flex flex-col items-center justify-center p-4'>
          <Box className='mb-[6px]'><TextWrapper classList="!text-[18px] !font-[600]" text={t('autoInvesting')} /></Box>
          <TextWrapper text={t('autoInvestPopupText')} />
          <Box className='mt-[16px] flex flex-col items-center'>
            <ButtonWrapper onClick={() => {
              onClose(true);
            }} classList="!w-fit" label={t('activateAutoInvestFeature')}></ButtonWrapper>
            <a className="!caption cursor-pointer hover:no-underline !text-[12px] underline mt-2" onClick={() => onClose()}>{t('skip')}</a>
          </Box>
        </Box>
      </Box>
    }
  ></DialogWrapper>;
};